var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2837 30 30 23.2837 30 15C30 6.71631 23.2837 0 15 0C6.71631 0 0 6.71631 0 15C0 23.2837 6.71631 30 15 30ZM24.2618 12.0964C24.2618 18.0592 19.7208 24.9372 11.421 24.9372C8.9674 24.9385 6.56512 24.2348 4.5 22.9099C4.85787 22.9534 5.21801 22.9755 5.57852 22.9761C7.61133 22.9793 9.58605 22.2982 11.1846 21.0425C10.243 21.0236 9.3308 20.7112 8.57529 20.1488C7.81977 19.5865 7.25867 18.8023 6.97027 17.9058C7.64598 18.0365 8.34272 18.0101 9.00656 17.8284C7.98455 17.6227 7.06531 17.0694 6.40512 16.2626C5.74492 15.4557 5.38451 14.4452 5.38516 13.4026V13.3468C6.01248 13.694 6.71341 13.8869 7.43004 13.9097C6.47547 13.2712 5.79984 12.2932 5.54044 11.1744C5.28105 10.0557 5.45737 8.88017 6.03355 7.88675C7.16722 9.28001 8.58102 10.4195 10.1833 11.2313C11.7856 12.0431 13.5406 12.5091 15.3346 12.5991C15.1108 11.6314 15.2121 10.617 15.6227 9.71256C16.0333 8.80818 16.7304 8.06424 17.6063 7.59578C18.4821 7.12732 19.4879 6.96043 20.468 7.12091C21.4482 7.28138 22.3483 7.76029 23.029 8.48359C24.0393 8.28376 25.0082 7.91337 25.8941 7.38831C25.5563 8.43304 24.8512 9.31986 23.9094 9.88437C24.8038 9.78046 25.6773 9.54141 26.5 9.17538C25.8945 10.0819 25.1322 10.8732 24.2489 11.512C24.2575 11.7054 24.2618 11.903 24.2618 12.0964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink4);
export default __webpack_public_path__ + "static/media/link4.95415bfea4b6336fd893d56aace04bf7.svg";
export { ForwardRef as ReactComponent };